import useCreateInventoryPosition from '@/application/write/positions/useCreateInventoryPosition';
import {
  ActionItem,
  ActionList,
  renderApproveContracts,
} from '../../modules/ActionList';
import { Address, TokenId, Vault } from 'nftx.js';
import { useNetwork } from '@nftx/react';
import useCreateInventoryPositionQuote from '@/application/read/positions/useCreateInventoryPositionQuote';
import Icon, { Icons } from '../../elements/Icon';
import { parseEther } from 'viem';

const Processing = ({
  vault,
  tokenIds,
  userAddress,
  vTokenAmount,
  using,
  onSuccess,
  onCancel,
}: {
  vault: Vault;
  tokenIds: [TokenId, number][];
  vTokenAmount: string;
  userAddress: Address;
  using: 'nft' | 'vtoken';
  onSuccess: () => void;
  onCancel: () => void;
}) => {
  const network = useNetwork();
  const { data: quote, error: quoteError } = useCreateInventoryPositionQuote({
    tokenIds: using === 'nft' ? tokenIds : undefined,
    userAddress,
    vaultId: vault.vaultId,
    vToken: using === 'vtoken' ? parseEther(vTokenAmount) : undefined,
  });
  const [write, { status, error }] = useCreateInventoryPosition();

  if (quoteError) {
    return (
      <div>
        <h1>Something went wrong</h1>
        <div>{(quoteError as any).message}</div>
      </div>
    );
  }

  if (!quote) {
    return (
      <div className="p-6 bg-gray-50 w-full flex justify-center items-center">
        <Icon name={Icons.SPINNER_GAP} className="animate-spin" />
      </div>
    );
  }
  const actionItems: JSX.Element[] = [];

  // Approve the NFTs for minting
  actionItems.push(
    ...renderApproveContracts({
      approveContracts: quote.approveContracts,
      index: 0,
      network,
      symbol: vault.token.symbol,
    })
  );

  // Create the position
  const onStakeInventory = () => {
    write({ quote, userAddress });
  };

  actionItems.push(
    <ActionItem
      key={actionItems.length}
      index={actionItems.length}
      label="Stake Inventory"
      status={status}
      error={error}
      action={onStakeInventory}
    />
  );

  return (
    <div className="max-w-md mx-auto space-y-6">
      <div className="p-4 rounded-lg border border-gray-300 overflow-hidden bg-gray-50">
        <ActionList
          title={`Stake ${vault.token.symbol} Inventory`}
          description=""
          onComplete={onSuccess}
          onCancel={onCancel}
        >
          {actionItems}
        </ActionList>
      </div>
    </div>
  );
};

export default Processing;
